import Env from 'Env';
import { fetchNotifications } from 'actions/notificationActions';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

/**
 * Calls the fetch notification periodically
 */
export const useNotification = () => {
  const dispatch = useDispatch();

  const interval = Env.getNotificationIntervalMinutes();
  
  useEffect(() => {
    // Fetch on mount
    dispatch(fetchNotifications());

    // Set up a timer to fetch notifications every x minutes
    const intervalId = setInterval(() => {
      dispatch(fetchNotifications());
    }, interval * 60 * 1000); // x minutes in milliseconds

    // Clean up the timer when the component unmounts
    return () => clearInterval(intervalId);
  }, []);
};